import React from 'react';
import LogoHeader from './LogoHeader';

/**
 * MainLayout - Layout principal avec les logos FSE+ obligatoires
 * S'applique à toutes les pages des utilisateurs connectés
 */
const MainLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* En-tête avec logos partenaires - FSE+ obligatoire */}
      <LogoHeader className="sticky top-0 z-50 shadow-sm" />
      
      {/* Contenu de la page */}
      <main className="relative">
        {children}
      </main>
    </div>
  );
};

export default MainLayout;
